// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__5ur3V","list":"PatternAutocomplete_list__17jlT"};